<template>
  <nav class="tabovi">
    <a v-for="t in tabovi" :key="t.id" :class="{ akt: aktivan === t.id }" @click.prevent="idi(t.id)">
      {{ t.naslov }}
      <span v-if="gresaka(t)" class="br">{{ gresaka(t) }}</span>
      <span v-if="izmjena(t)" class="bi" title="nespremljene izmjene"></span>
    </a>
  </nav>
</template>

<script>
// Sidrišta unutar jedne forme: tabovi = [{ id: 'k-osobni', naslov: 'Osobni', kljucevi: ['First', ...] }].
// id je id kartice (FormaKartica id). Mora biti unutar FormaOkvir (i u slotu "tabovi" od FormaTraka).
export default {
  name: 'FormaTabovi',
  inject: ['okvir'],
  props: { tabovi: { type: Array, default: () => [] } },
  data () { return { aktivan: '' } },
  mounted () {
    this.aktivan = this.tabovi.length ? this.tabovi[0].id : ''
    window.addEventListener('scroll', this.osvjezi, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.osvjezi)
  },
  methods: {
    gresaka (t) { return (t.kljucevi || []).filter(k => this.okvir.greske[k]).length },
    izmjena (t) { return (t.kljucevi || []).some(k => this.okvir.izmijenjena.indexOf(k) >= 0) },
    idi (id) {
      this.aktivan = id
      this.okvir.skociNaKarticu(id)
    },
    osvjezi () {
      let akt = this.tabovi.length ? this.tabovi[0].id : ''
      this.tabovi.forEach(t => {
        const el = document.getElementById(t.id)
        if (el && el.getBoundingClientRect().top <= 190) akt = t.id
      })
      this.aktivan = akt
    }
  }
}
</script>
